<template>
  <div class="relative min-h-4 flex items-center gap-1.5" data-test-id="product-swatches">
    <vf-color-picker
      v-for="({ id, label, swatch, available }, i) in swatches.slice(0, 6)"
      :key="id"
      :active="modelValue === id"
      :class="{ '<lg:hidden': i >= 4 }"
      :color="swatch?.color"
      :lazy
      :name="label"
      :size
      :thumbnail="swatch?.image"
      :treatment
      :unavailable="!available"
      :variant="shape"
      @click="select(id, label)"
    />
    <base-button
      v-if="swatches.length > 4"
      class="h-4 shrink-0 text-xs c-grey-20 fw-bold lh-none duration hover:c-brand-1"
      :class="{ 'lg:hidden': swatches.length <= 6 }"
      data-test-id="product-swatches-more"
      @click="$emit('more')"
    >
      <span :aria-label="replaceAll($t.moreColorsCount, { count: swatches.length - 4 })" class="lg:hidden">+{{ swatches.length - 4 }}</span>
      <span :aria-label="replaceAll($t.moreColorsCount, { count: swatches.length - 6 })" class="<lg:hidden">+{{ swatches.length - 6 }}</span>
    </base-button>
  </div>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#commerce/components/product/swatches/Swatches.vue'

defineProps<Props>()

defineEmits<Emits>()

const { $gtm } = useNuxtApp()

const modelValue = defineModel<string>()

const { shape = 'rectangle', size, treatment } = useAppConfig().components.product?.swatches || {}

const select = (id: string, label: string) => {
  modelValue.value = id
  $gtm.push('plpPage.onSelectColor', `${id} - ${label}`)
}
</script>
